// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/model',
    name: 'Model',
    component: layout,
    redirect: '/model/index',
    meta: {
      title: '分模型分析',
      icon: 'i-menu:model',
      i18Key: 'router.user.model.title',
      roles: [1],
      category: 'insight'
    },
    sort: 20,
    children: [
      {
        path: 'index',
        name: 'ModelIndex',
        component: () => import('@/views/Model/Index.vue'),
        meta: {
          title: '分模型分析',
          icon: 'i-menu:model',
          i18Key: 'router.user.model.index',
          roles: [1],
          headerConditions: ['brand', 'keyword', 'cycleType', 'location']
        }
      }
    ]
  }
]
export default routes
